<div class="folder-row"
     (click)="handleClick($event,data)">
  <mat-icon style="font-size: 20px; height: 20px; width: 20px;">
    folder
  </mat-icon>
  <h5 style="margin: 0 0 0 8px; font-size: 14px;">
    {{data.label || data.name}}
  </h5>
</div>
